<template>
    <div>
        <nav-tabs :tabs="routes" :exact="false"/>
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import NavTabs from "../../components/layouts/NavTabs.vue";
import PermissionMixin from "../../mixins/PermissionMixin.vue";
import { mapState } from "pinia";
import {Store} from "../../stores/store";

export default {
    components: {NavTabs},
    mixins: [PermissionMixin],
    data() {
        return {
            routes: [
                { label: "Dashboard", route: "kyc.dashboard" },
                { label: "Revalidação biométrica", route: "kyc.biometric-revalidation" },
            ],
        };
    },

    computed: {
        ...mapState(Store, ['permissions'])
    },

    watch: {
        permissions() {
            this.permissionMenus();
        }
    },

    mounted() {
        this.permissionMenus();
    },

    methods: {
        permissionMenus() {
        },
        pushRoute(route) {
            if (this.hasPermission(route.permission) && !this.routes.some(route => route.route === route)) {
                this.routes.push(route);
            }
        }
    }
};
</script>
